import{useState as t,useEffect as e}from"react";import{createPortal as n}from"react-dom";const o=({children:o,elementId:l})=>{const[r,m]=t(null);return e((()=>(setTimeout((()=>{const t=document.getElementById(l);m(t)}),500),()=>{m(null)})),[l]),r?n(o,r):null};export{o as default};
//# sourceMappingURL=Portal.js.map
